module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel_btn":"Abbrechen","okay_btn":"OK","today_text":"heute"},"en":{"cancel_btn":"Cancel","okay_btn":"OK","today_text":"today"}}')
  delete Component.options._Ctor
}
